import React from "react";

function Hyderabad(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6.04639 23.0757H17.3133"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M4.50793 15.3413H7.82617V23.0758H4.50793V15.3413Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M5.18677 2.87695H7.14754V4.33396H5.18677V2.87695Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M4.50793 4.36426H7.82617V6.47285H4.50793V4.36426Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M5.31372 6.47559H7.02412V8.58417H5.31372V6.47559Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M3.98071 8.5874H8.35475V10.696H3.98071V8.5874Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M6.16724 15.3413V23.0758"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M3.98071 13.2329H8.35475V15.3415H3.98071V13.2329Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path d="M6.16724 1.47119V2.87692V1.47119Z" fill="white" />
      <path
        d="M6.16724 1.47119V2.87692"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M4.50793 10.6958H7.82617V13.2327H4.50793V10.6958Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path d="M8.23303 9.87842H16.3144H8.23303Z" fill="white" />
      <path
        d="M8.23303 9.87842H16.3144"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path d="M7.70642 11.8394H16.8828H7.70642Z" fill="white" />
      <path
        d="M7.70642 11.8394H16.8828"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path d="M8.23303 14.5542H16.3144H8.23303Z" fill="white" />
      <path
        d="M8.23303 14.5542H16.3144"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M16.634 15.3413H19.9523V23.0758H16.634V15.3413Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M17.3124 2.87695H19.2732V4.33396H17.3124V2.87695Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M16.634 4.36426H19.9523V6.47285H16.634V4.36426Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M17.4406 6.47559H19.151V8.58417H17.4406V6.47559Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M16.1069 8.5874H20.481V10.696H16.1069V8.5874Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M18.2942 15.3413V23.0758"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M16.1069 13.2329H20.481V15.3415H16.1069V13.2329Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path d="M18.2942 1.47119V2.87692V1.47119Z" fill="white" />
      <path
        d="M18.2942 1.47119V2.87692"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M16.634 10.6958H19.9523V13.2327H16.634V10.6958Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M15.0967 23.0757V19.1058C15.0967 18.3426 14.7935 17.6106 14.2538 17.0709C13.7141 16.5312 12.9821 16.228 12.2189 16.228C11.4556 16.228 10.7237 16.5312 10.184 17.0709C9.64426 17.6106 9.34106 18.3426 9.34106 19.1058V23.0757H15.0967Z"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M9.34106 9.87842V11.8392"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M12.2194 9.7666V11.839V14.391"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
      <path
        d="M14.9458 9.87842V11.8392"
        stroke="#17142A"
        strokeWidth="0.401244"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

const MemoHyderabad = React.memo(Hyderabad);
export default MemoHyderabad;
